import { DocProgress, DocProgressMap } from "@types";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetDocuments } from "src/hooks/queries";

/**
 * Get the progress/status of all the documents.
 * Maps from document id to DocProgress.
 */
export const useDocProgressMap = (deviceId: string): DocProgressMap => {
  const { orgId = "" } = useParams();
  const { data: documents } = useGetDocuments(orgId, deviceId, {
    queryKeyOrgId: deviceId ? undefined : orgId,
  });

  return useMemo(() => {
    const newDocProgressMap: Record<string, DocProgress> = {};

    if (!documents) {
      return {};
    }

    documents.forEach((doc) => {
      newDocProgressMap[doc.id] = {
        title: doc.title,
        docId: doc.id,
        functionalGroupId: doc.functionalGroupId || null,
        complete: doc.versions[0]?.readyForApproval === true,
        noVersion: doc.versions.length === 0,
        incompleteTemplates: [], //TODO: re-add this back in
      };
    });

    return newDocProgressMap;
  }, [documents]);
};
